var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoBox"},[_c('video',{staticClass:"video",attrs:{"src":_vm.teamDetails.videoUrl,"laysinline":"","autoplay":"false","controls":"","controlslist":"nodownload"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }